<template>
<div>
   <vs-row vs-type="flex">
      <ValidationObserver ref="addMultipleObserver">
        <vs-col vs-justify="flex-start" vs-lg="3" class="p-3">
          <ValidationProvider :name="$t('CashFlow.ElementYearlyPrice.Element')" rules="required" v-slot="{ errors }">
            <form-label>{{$t('CashFlow.ElementYearlyPrice.Element')}}</form-label>
            <v-select
              :options="elements"
              label="name"
              :reduce="element => element.id"
              v-model="element"
              class="w-full"
              name="elementId"
            />
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="2" class="p-3">
          <ValidationProvider :name="$t('CashFlow.ElementYearlyPrice.StartYear')" rules="required|numeric|between:1990,2100" v-slot="{ errors }">
            <validated-input :label="$t('CashFlow.ElementYearlyPrice.StartYear')" 
              v-model="startYear"
              class="nowrap">
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="2" class="p-3">
          <ValidationProvider :name="$t('CashFlow.ElementYearlyPrice.EndYear')" rules="required|numeric|between:1990,2100" v-slot="{ errors }">
            <validated-input :label="$t('CashFlow.ElementYearlyPrice.EndYear')" 
              v-model="endYear"
              class="nowrap">          
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="1" class="p-3">
          <ValidationProvider :name="$t('CashFlow.ElementYearlyPrice.Price')" rules="required|decimal|min_value:1" v-slot="{ errors }">
            <validated-input :label="$t('CashFlow.ElementYearlyPrice.Price')" 
              v-model="price"
              class="nowrap">
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col v-if="!readOnly" vs-type="flex" vs-justify="flex-start" vs-lg="3" class="align-items-center mt-8 pt-1" >
          <vs-button type="border" class="align-items-center" color="danger" @click="addMultipleElements" >{{ $t('CashFlow.ElementYearlyPrice.BatchAddTitle') }}</vs-button>
        </vs-col>
      </ValidationObserver>
    </vs-row>
    <vs-row class="yesscroll">

      <element-yearly-prices-table :yearlyPrices="yearlyPrices" :readOnly="false" />
    </vs-row>
</div>

</template>
<script>

import ElementEnum from "@/app/shared/ElementEnum.js";
import vSelect from 'vue-select';

import {
  FormLabel,
  ValidatedInput,
  ValidationMessage
} from "@/app/shared/components";

import ElementYearlyPricesTable from './ElementYearlyPricesTable.vue'

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    FormLabel,    
    vSelect,
    ValidatedInput,
    ValidationMessage,
    ElementYearlyPricesTable
  },
  props: {
    readOnly : {
      type: Boolean,
      default: false
    },
    templateId : {
      type: Number
    },
    yearlyPrices: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      isMounted: false,
      startYear: null,
      endYear: null,
      element: null,
      price: 0,
      context: { componentParent: this },
      elements: [
        { name: this.getElementName(ElementEnum.Gold), id: ElementEnum.Gold },
        { name: this.getElementName(ElementEnum.Silver), id: ElementEnum.Silver }
      ]
    };
  },
  created() {
    this.initValues();
  },

  computed: {
    years () {
      return this.$props.yearlyPrices.map(item => item.values.map(v => v.year))[0];
    }
  },

  methods: {
    initValues() {
      if (this.data) return;
      this.startYear = new Date().getFullYear();
      this.endYear = null;
      this.element = ElementEnum.Gold;
      this.price = 0;
    },
    addMultipleElements() {
      this.$refs.addMultipleObserver.validate().then(result => {
        if (result) {
          this.$vs.loading();
          this.$cqrsPost('cashflow/lom/elementYearlyPriceTemplates/addMultiplePrices', { 
            templateId: this.templateId,
            element: this.element,
            startYear: this.startYear,
            endYear: this.endYear,
            price: this.price
          }).then((response) => {
            this.$notifySaveSuccess();
            this.$emit("onRebindYearlyPrices", response.data.model);
          }).finally(() => {
            this.$vs.loading.close();
          });
        }
      });
    },
    getElementName(element) {
      return this.$t("Element." + element);
    } //,
    // onEditPrice(event, elementYearlyPriceId) {
    //   const value = event.target.value;
    //   if (value === null || value === "") {
    //     return;
    //   }

    //   if (Number(value) === 0) {
    //     this.deletePrice(elementYearlyPriceId);
    //     return;
    //   }

    //   this.$cqrsPost('cashflow/lom/elementYearlyPriceTemplates/EditElementYearlyPrice', { 
    //     id: elementYearlyPriceId,
    //     price: value
    //   }).finally(() => {
    //     this.$vs.loading.close();
    //   });
    // },

    // deletePrice(elementYearlyPriceId) {
    //   this.$cqrsPost('cashflow/lom/elementYearlyPriceTemplates/DeleteElementYearlyPrice', { 
    //     id: elementYearlyPriceId
    //   }).then(() => {
    //     const flattenedYearlyPrices = this.yearlyPrices.flatMap(x => x.values);
    //     const nowDeletedPrice = flattenedYearlyPrices.find(x => x.id === elementYearlyPriceId);
    //     nowDeletedPrice.id = null;
    //     nowDeletedPrice.price = null;
    //   }).catch((response) => {
    //     console.log(response);
    //   });
      
    // }
  }
};
</script>

<style lang="scss">


  .nowrap {
    white-space: nowrap;
  }

  .noscroll {
    overflow: initial !important;
  }

  .yesscroll {
    overflow-x: auto;
  }

</style>